export type PanelStep = 'Left' | 'Right' | 'Up' | 'Down' | 'Near' | 'Far';
/** Move relative to the panel's facing direction, including after rotation. */
export function stepPanel(position: [number, number, number], yaw: number, step: PanelStep): [number, number, number] {
  const next: [number, number, number] = [...position];
  if (step === 'Up' || step === 'Down') next[1] += step === 'Up' ? .25 : -.25;
  else {
    const sideways = step === 'Left' || step === 'Right';
    const direction = step === 'Left' || step === 'Far' ? -.25 : .25;
    next[0] += direction * (sideways ? Math.cos(yaw) : Math.sin(yaw));
    next[2] += direction * (sideways ? -Math.sin(yaw) : Math.cos(yaw));
  }
  return next;
}
